import HudCompass from './HudCompass'
import RiskIndex from './RiskIndex'

export default function Hero({ articleCount }: { articleCount: number }) {
  return (
    <section className="wrap hero">
      <div className="hero-grid">
        <div className="hero-copy">
          <div className="eyebrow">
            <span className="live-dot" aria-hidden="true"></span>
            <span className="mono-sm">
              Field Dispatch &middot; Live &middot; <span className="tnum">Updated every 48 hrs</span>
            </span>
          </div>
          <h1>
            Be Prepared.
            <br />
            <span className="l2">Stay Savage.</span>
          </h1>
          <p className="sub">
            A working manual for real self-reliance: <b>food and water, home hardening, off-grid power, skills, and community</b>. Calm,
            tested, and current. No camo cosplay, no doomsday theater.
          </p>
          <div className="cta-row">
            <a className="btn sig" href="#start">
              <span>Start Here</span>
              <span className="arw" aria-hidden="true">
                &rarr;
              </span>
            </a>
            <a className="btn" href="#articles">
              <span>Latest Dispatches</span>
            </a>
          </div>
        </div>

        <div className="instr instr-solo">
          <HudCompass articleCount={articleCount} />
          <RiskIndex />
        </div>
      </div>
    </section>
  )
}
